import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/heatmapSaga";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import SecondaryCategory from "./smartComponents/secondaryCategory";
import Heatmap from "../../../shared/heatmap/Heatmap";
import "./HeatmapModule.scss";

const HeatmapModule = ({ membership_logic }) => {
  const dispatch = useDispatch();
  const { fetchHeatmapData } = actionCreators;
  const { filtersDirty, isLoading } = useSelector((state) => state.retentionHeatmap);
  const { useSecondaryCategories, sourceType, short_url, organization_id } = useSelector(
    (state) => state.commonReducer.commonProps
  );

  const renderUpdateBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button
          className="submit override-submit"
          onClick={() => dispatch(actionCreators.updateHeatmapData())}
        >
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button
          className="submit reset override-submit"
          onClick={() => dispatch(actionCreators.resetFilters())}
        >
          Reset
        </button>
      );
    }
  };

  return (
    <SectionToggle
      maxHeight="auto"
      autoHeight
      title="Membership Retention Heatmap"
      customClass="class-check-in-heatmap withSticky"
      learnMore={
        <KBLearnMore
          title="Membership Retention Heatmap"
          description="This report visualizes monthly membership retention patterns over time, showing when members are most likely to disengage. These insights help you detect risk points in the member lifecycle and take proactive steps to improve long-term retention."
          kbUrl={ILEARN_URLS.membership.membershipRetentionHeatmap}
        />
      }
      content={
        <>
          <div id="react-heatmap-overlay"></div>
          <div className="chart-holder">
            {membership_logic !== "NumberOfMembersByProfile" ? (
              <div id="heatmap-edit-selection-bar" className="edit-selections-bar">
                <div className="select-box-no-width">
                  <p>{useSecondaryCategories ? "Secondary Category" : "Category"}</p>
                  <SecondaryCategory />
                </div>
                {renderUpdateBtn()}
                {renderResetBtn()}
              </div>
            ) : null}
            <Heatmap
              stateName="retentionHeatmap"
              params={{ short_url, organization_id }}
              sourceType={sourceType}
              membershipLogic={membership_logic}
              fetchHeatmapData={fetchHeatmapData}
            />
          </div>
        </>
      }
    />
  );
};

export default React.memo(HeatmapModule);
